var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationEditorDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 925,
    height: 882,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "27.881%",
    x2: "100%",
    y2: "72.119%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "41.725%",
    x2: "100%",
    y2: "58.275%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-11.7%",
    width: "121.8%",
    height: "132.8%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.421821759 0 0 0 0 0.554338424 0 0 0 0 0.893710371 0 0 0 0.243444056 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 642,
    height: 427,
    rx: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2D2E40",
    opacity: 0.08,
    transform: "matrix(1 0 0 -1 0 890)",
    x: 145,
    y: 144,
    width: 600,
    height: 602,
    rx: 300
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.5,
    transform: "matrix(1 0 0 -1 0 882)",
    x: 105.5,
    y: 100.5,
    width: 679,
    height: 681,
    rx: 339.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.25,
    transform: "matrix(1 0 0 -1 0 882)",
    x: 5.5,
    y: 0.5,
    width: 879,
    height: 881,
    rx: 439.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3 125h636a3 3 0 013 3v296a3 3 0 01-3 3H3a3 3 0 01-3-3V128a3 3 0 013-3z",
    fill: "#2D2E40",
    fillRule: "nonzero",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: 90.523,
    y: 47.709,
    width: 135.785,
    height: 137.165,
    rx: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2D2E40",
    mask: "url(#d)",
    cx: 158.416,
    cy: 116.888,
    rx: 39.306,
    ry: 39.36
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: 248.939,
    y: 47.709,
    width: 302.538,
    height: 325.617,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209 284c47.125-73.367 81.977-113.013 104.557-118.938 33.87-8.886 23.765 83.14 72.535 72.473 48.77-10.666 54.716-103.974 91.603-108.37 36.887-4.397 56.402 80.946 72.515 88.81 10.742 5.241 24.005-6.094 39.79-34.007",
    stroke: "url(#e)",
    strokeWidth: 8,
    strokeLinecap: "round",
    transform: "translate(0 242)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEditorDesktop);
export default __webpack_public_path__ + "static/media/illustration-editor-desktop.c6c8050aa4dcf0c64b4406570c970d2b.svg";
export { ForwardRef as ReactComponent };